import React, { useState, useEffect } from 'react';
import { ProfileHeader } from '../components/profile/ProfileHeader';
import { Layout } from '../components/layout/Layout';
import { NativeBanner } from '../components/ads';
import { auth } from '../services/firebase';
import { updateUserAvatar } from '../services/auth';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import RecentTrailers from '../components/profile/RecentTrailers';
import styled from 'styled-components';
import { useScrollToTopOnMount } from "../hooks/useScrollToTop";

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  margin: 2rem 0 1rem;
  color: var(--color-text-primary);
  font-weight: 600;
`;

const Section = styled.div`
  margin-bottom: 2rem;
  background: var(--color-background-alt);
  border-radius: var(--border-radius);
  padding: var(--spacing-4);
`;

export const Profile = () => {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [showSettings, setShowSettings] = useState(false);
  
  // Scroll automatique vers le haut au chargement
  useScrollToTopOnMount();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        setUser({
          displayName: currentUser.displayName || 'Utilisateur',
          email: currentUser.email || '',
          photoURL: currentUser.photoURL || ''
        });
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleAvatarUpdate = async (url: string) => {
    if (user && auth.currentUser) {
      try {
        await updateUserAvatar(auth.currentUser.uid, url);
        setUser({
          ...user,
          photoURL: url
        });
      } catch (error) {
        console.error('Error updating avatar:', error);
      }
    }
  };

  const handleSettingsClick = () => {
    setShowSettings(!showSettings);
  };

  if (loading) {
    return (
      <Layout>
        <div className="container mx-auto px-4 flex justify-center items-center" style={{ minHeight: '50vh' }}>
          <LoadingSpinner />
        </div>
      </Layout>
    );
  }

  if (!user) {
    return (
      <Layout>
        <div className="container mx-auto px-4">
          <h1>Vous devez être connecté pour accéder à cette page</h1>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="container mx-auto px-4">
        <ProfileHeader 
          user={user}
          onAvatarUpdate={handleAvatarUpdate}
          onSettingsClick={handleSettingsClick}
          showSettings={showSettings}
        />
        {showSettings && (
          <div className="mb-6 p-4 bg-gray-800 rounded-lg">
            {/* Contenu des paramètres ici */}
            <h2 className="text-xl mb-4">Paramètres du profil</h2>
            {/* Ajoutez ici les paramètres du profil */}
          </div>
        )}
        
        <Section>
          <SectionTitle>Dernières bandes-annonces regardées</SectionTitle>
          <RecentTrailers />
        </Section>
        
        <NativeBanner />
      </div>
    </Layout>
  );
};

export default Profile;